import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ICreateChannelAttributeGroupRequestBody } from './types';

export const createChannelAttributeGroup = async (
  productId: string,
  payload: ICreateChannelAttributeGroupRequestBody,
  file: File | null,
) => {
  const requestBody = new FormData();
  requestBody.append('data', JSON.stringify(payload));
  if (file) {
    requestBody.append('files', file);
  }
  return fetch(`${API_URL}/items/${productId}/rules`, {
    method: 'POST',
    body: requestBody,
  });
};
